import { type ReactElement, type ReactNode } from 'react';

import styles from './FormTitle.module.scss';

export function FormTitle({ children }: { children: ReactNode }): ReactElement {
  return <h1 className={styles['form-title']}>{children}</h1>;
}
